/* router.svelte.ts generated by Svelte v5.55.3 */
import * as $ from 'svelte/internal/client';

let currentPath = $.state($.proxy(window.location.pathname));

export function getPath() {
	return $.get(currentPath);
}

export function navigate(path) {
	if (path === $.get(currentPath)) return;

	window.history.pushState({}, "", path);
	$.set(currentPath, path, true);
	window.scrollTo(0, 0);
}

export function matchRoute(pattern) {
	if (pattern.endsWith("/*")) {
		const prefix = pattern.slice(0, -2);

		return $.get(currentPath) === prefix || $.get(currentPath).startsWith(prefix + "/");
	}

	return $.get(currentPath) === pattern;
}

export function getSegment(index) {
	return $.get(currentPath).split("/").filter(Boolean)[index];
}

window.addEventListener("popstate", () => {
	$.set(currentPath, window.location.pathname, true);
});